// extracted by mini-css-extract-plugin
module.exports = {"VideoWrapper":"Movie_VideoWrapper__24o5i","fadeIn":"Movie_fadeIn__3807_","modalFadeIn":"Movie_modalFadeIn__ST8ka","slideInFromRight":"Movie_slideInFromRight__214U3"};